<template>
  <div style="display: flex">
    <el-select v-model="obj.province.id" style="flex: 1;" placeholder="省"  :size="size" @change="getCityData">
      <el-option v-for="item in addressArray" :key="item.id" :label="item.name" :value="item.id" />
    </el-select>
    <el-select v-model="obj.city.id" style="flex: 1;margin-left:2px;" placeholder="市"  :size="size" @change="getAreaData">
      <el-option v-for="item in cityArray" :key="item.id" :label="item.name" :value="item.id" />
    </el-select>
    <el-select v-model="obj.area.id" style="flex: 1;margin-left:2px;" placeholder="县"  :size="size" @change="getXianData">
      <el-option v-for="item in areaArray" :key="item.id" :label="item.name" :value="item.id" />
    </el-select>
  </div>
</template>

<script>
import Common from '@/api/common/common'
let getArea = Common.getArea
export default {
  name: 'Liareaselect',
  props: {
    provinceId: {
      type: [String, Number],
    },
    cityId: {
      type: [String, Number],
    },
    areaId: {
      type: [String, Number]
    },
    areaName:{
      type: [String, Number]
    },
    domain32:{
      type: [String, Number]
    },
    size: {
      type: String,
      default: 'medium'
    },
  },
  data() {
    return {
      addressArray: [], // 所有数据
      cityArray: [],
      areaArray: [],
      obj: {
        province: { id: null, name: null }, // 省
        city: { id: null, name: null }, // 市
        area: { id: null, name: null, domain32: null }, // 县
      },
    }
  },
  created() {
    console.log('Liareaselect.vue-------------------', this.provinceId, this.cityId, this.areaId)
    this.obj.province.id = parseInt(this.provinceId) || null
    this.obj.city.id = parseInt(this.cityId) || null
    this.obj.area.id = parseInt(this.areaId) || null
    this.getProvInfo()
    this.getCityInfo(this.obj.province.id)
    this.getAreaInfo(this.obj.city.id)
  },

  watch: {
    provinceId(value){
      let id = parseInt(value) || null
      if(id !== this.obj.province.id){
        this.obj.province.id = id
        this.getCityInfo(value)
      }
    },
    cityId(value){
      let id = parseInt(value) || null
      if(id !== this.obj.city.id){
        this.obj.city.id = id
        this.getAreaInfo(id)
      }
    },
    areaId(value){
      let id = parseInt(value) || null
      if(id !== this.obj.area.id){
        this.obj.area.id = id
      }
    }
  },
  methods: {
    // 获取省信息
    getProvInfo() {
      const param = {}
      getArea(param)
        .then((res) => {
          this.addressArray = res.data.children
        })
        .catch((error) => {
          // 捕获异常
          console.log(error)
        })
    },
    // 获取市
    getCityInfo(id) {
      id = parseInt(id) 
      if(!id) return
      const param = {
        id: id,
      }
      getArea(param)
        .then((res) => {
          this.cityArray = res.data.children
        })
        .catch((error) => {
          console.log(error) // 捕获异常
        })
    },
    // 获取县区
    getAreaInfo(id) {
      id = parseInt(id) 
      if(!id) return
      const param = {
        id: id,
      }
      getArea(param)
        .then((res) => {
           let name = ''
           let domain32 = ''
          for(var item of this.cityArray){
               if(item.id === id){
                name = item.name
                domain32 = item.domain32
                break
              }
           }
          let a = this.areaName ? this.areaName  : name
          let b = this.domain32 ? this.domain32 : domain32
          this.areaArray = res.data.children.length >0 ? res.data.children : [{ id: id,name: a,domain32:b}]
        })
        .catch((error) => {
          console.log(error) // 捕获异常
        })
    },

    // 选择省份listenArea
    getCityData(val) {
      this.getCityInfo(val)
      this.obj.province.id = val
      this.addressArray.forEach(item=>{
        if(item.id === val){
          this.obj.province.name = item.name
        }
      })
      this.obj.city.id = null
      this.obj.city.name = null
      this.obj.area.id = null
      this.obj.area.name = null
      this.$emit('listenPro', this.obj)
    },
    getAreaData(val) {
      this.getAreaInfo(val)
      this.obj.city.id = val
      this.cityArray.forEach(item=>{
        if(item.id === val){
          this.obj.city.name = item.name
        }
      })
      this.obj.area.id = null
      this.obj.area.name = null
      this.$emit('listenPro', this.obj)
    },
    getXianData(val) {
      this.obj.area.id = val
      this.areaArray.forEach(item=>{
        if(item.id === val){
          this.obj.area.name = item.name
          this.obj.area.domain32 = item.domain32
        }
      })
      this.$emit('listenPro', this.obj)
    },
    emptyData() {
      this.obj = {
        province: { id: null, name: null }, // 省
        city: { id: null, name: null }, // 市
        area: { id: null, name: null }, // 县
      }
      this.$emit('listenPro', this.obj)
    },
  },
}
</script>

<style scoped></style>
